import { createFileRoute } from '@tanstack/react-router';
import { KpiDocumentStatusTable } from '@/modules/kpi/kpi-document-status';

export const Route = createFileRoute(
  '/(dashboard)/_dashboard/performance-review/$id/document-status'
)({
  component: KpiDocumentStatusTable,
});
